import * as types from '../actions/actionTypes';
import initialState from './initialState';

const userSearch = (state, action) => {
    switch(action.type){
        case types.ADMIN__SEARCH_USERS_REQUEST:
            return {...state, search: action.criteria};
        case types.ADMIN__SEARCH_USERS_SUCCESS:
            return {...state, results: action.response};
        case types.ADMIN__UPDATE_DELIVERY_TESTER_SUCCESS:{
            const index = state.results.findIndex(u => u.id === action.payload.userId);
            const results = [...state.results];
            results[index] = {...results[index], isDeliveryTester: action.payload.isDeliveryTester};
            return {...state, results};
        }
        case types.ADMIN__FETCH_UPDATED_USER_SUCCESS:{
            const index = state.results.findIndex(u => u.id === action.payload.userId);
            const results = [...state.results];
            results[index] = action.response;
            return {...state, results};
        }
        case types.ADMIN__DELETE_USER_SUCCESS:{
            const index = state.results.findIndex(u => u.id === action.payload.user.userId);
            const results = [...state.results.slice(0, index), ...state.results.slice(index + 1)];
            return {...state, results};
        }
        default: 
            return state;
    }
};

export default function adminReducer (state=initialState.admin, action){
    switch(action.type) {
        case types.ADMIN__SEARCH_USERS_REQUEST:
            return {...state, userSearch: userSearch(state.userSearch, action)};
        case types.ADMIN__SEARCH_USERS_SUCCESS:
            return {...state, userSearch: userSearch(state.userSearch, action)};
        case types.ADMIN__SEND_PASSWORD_RESET_REQUEST:
            return {...state, userSearch: userSearch(state.userSearch, action)};
        case types.ADMIN__FETCH_UPDATED_USER_SUCCESS:
            return {...state, userSearch: userSearch(state.userSearch, action)};
        case types.ADMIN__DELETE_USER_SUCCESS:
            return {...state, userSearch: userSearch(state.userSearch, action)};
        case types.ADMIN__UPDATE_DELIVERY_TESTER_SUCCESS:
            return {...state, userSearch: userSearch(state.userSearch, action)};
        case types.ADMIN__FETCH_ADMIN_STATE_SUCCESS:
            return {...state, ...action.response, loading: false, loaded: true};
        case types.ADMIN__FETCH_ADMIN_STATE_REQUEST:
            return {...state, loading: true};

        case types.ADMIN__FETCH_STAFF_VERIFY_SUCCESS:
            return {...state, pendingVerifications:action.response, loading: false, loaded: true};
        case types.ADMIN__FETCH_STAFF_VERIFY_REQUEST:
            return {...state, loading: true};
        case types.ADMIN__FETCH_STAFF_VERIFY_FAILURE:
            return {...state, loading: false, loaded: false, error: action.error};

        case types.ADMIN__UPDATE_STAFF_VERIFY_SUCCESS:
            return {...state, loading: false, loaded: true};
        case types.ADMIN__UPDATE_STAFF_VERIFY_REQUEST:
            return {...state, loading: true};
        case types.ADMIN__UPDATE_STAFF_VERIFY_FAILURE:
            return {...state, loading: false, loaded: false, error: action.error};


        case types.ADMIN__FETCH_CHAT_OPTIONS_SUCCESS:            
            return {...state, chatSchedule: (action.response != null) ? action.response : state.chatSchedule, loading: false, loaded: true};
        case types.ADMIN__FETCH_CHAT_OPTIONS_REQUEST:
            return {...state, loading: true};
        case types.ADMIN__FETCH_CHAT_OPTIONS_FAILURE:
            return {...state, loading: false, loaded: false, error: action.error};

        case types.ADMIN__UPDATE_CHAT_OPTIONS_SUCCESS:
            return {...state, loading: false, loaded: true};
        case types.ADMIN__UPDATE_CHAT_OPTIONS_REQUEST:
            return {...state, loading: true, error: null};
        case types.ADMIN__UPDATE_CHAT_OPTIONS_FAILURE:
            return {...state, loading: false, loaded: false, error: action.error};
        case types.ADMIN__GET_SYSTEM_TOGGLES_SUCCESS:
            return {...state, systemToggles: action.response};
        case types.ADMIN__UPDATE_SYSTEM_TOGGLES_SUCCESS:
            return {...state, systemToggles: action.payload.toggle};
        default:
            return state;
    }
}
